
import React, { createContext, useContext, useState, ReactNode } from 'react';
import { HierarchyRole, AccessLevel, canAccessLevel, DeviceHierarchy } from '@/types/hierarchy';
import { mockHierarchyData } from '@/data/mockHierarchy';

interface HierarchyContextType {
  userRole: HierarchyRole;
  setUserRole: (role: HierarchyRole) => void;
  canAccess: (level: AccessLevel) => boolean;
  hierarchyData: DeviceHierarchy;
}

const HierarchyContext = createContext<HierarchyContextType | undefined>(undefined);

export const HierarchyProvider = ({ children }: { children: ReactNode }) => {
  const [userRole, setUserRole] = useState<HierarchyRole>('system-administrator');
  
  const canAccess = (level: AccessLevel) => {
    return canAccessLevel(userRole, level);
  };

  return (
    <HierarchyContext.Provider value={{
      userRole,
      setUserRole,
      canAccess,
      hierarchyData: mockHierarchyData
    }}>
      {children}
    </HierarchyContext.Provider>
  );
};

export const useHierarchy = () => {
  const context = useContext(HierarchyContext);
  if (context === undefined) {
    throw new Error('useHierarchy must be used within a HierarchyProvider');
  }
  return context;
};
